import Vue from 'vue'
import axios from 'axios'
import { MessageBox } from 'element-ui'
import router from '../router'  // 导入 router 实例
import store from '../vuex'   // 导入 store 实例
// const BASE_URL = 'http://192.168.124.7:8081' // 朱盼
// const BASE_URL = 'http://192.168.1.134:8081' // 桂金

// const BASE_URL = 'http://192.168.1.124:8081' // 潘满园
//  const BASE_URL = 'http://192.168.1.7:8081' // 陈帅伟
// const BASE_URL = 'https://35l437z528.eicp.vip'
// const BASE_URL = 'https://test.feishazoushi.cn/admin' // 测试服务器

// const BASE_URL = 'http://neol.mynatapp.cc' // 映射地址
const BASE_URL = 'https://feishazoushi.cn/admin' // 线上地址
axios.interceptors.request.use(
  config => {
    var token = sessionStorage.getItem('token')
    if (token && token != '') config.headers['token'] = token
    {
    }
    return config 
  },
  err => {
    return Promise.reject(err)
  }
)
// 响应拦截器 - 用于获取响应头数据
// axios.interceptors.response.use(
//   response => {
//     if (router.history.current.path === '/Login') return response
//     if(response.data && response.data.code==599){
//       console.log(router,'router')
//         MessageBox.alert('该账号已在其他地方登录，如非本人操作，请尽快修改密码！', '', {
// 						confirmButtonText: '确定',
// 						type: 'warning',
// 						showClose: false
// 					}).then(() => {
// 						store.commit('setUser', '')
// 						store.commit('setNavHistoy', '')
// 						store.commit('setSole', '')
// 						store.commit('upEditableTabs', [])
// 						store.commit('setHistTabsValue', '')
//             sessionStorage.removeItem('token')
//             router.push('/Login')
// 					}).catch(() => { });
//       }
//     return response
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )
axios.defaults.timeout = 120000 // 在超时时间
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8' // 配 置请求头
axios.defaults.baseURL = BASE_URL
axios.defaults.withCredentials = true
Vue.prototype.axios = axios
